import { CommonModule } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgModule } from '@angular/core';
import { PhxDraggableListComponent } from './phx-draggable-list.component';
import { PhxIconModule } from '../icon/icon.module';
import { PhxButtonModule } from '../button/phx-button.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxTooltipModule } from '../tooltip/phx-tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    DragDropModule,
    PhxIconModule,
    PhxButtonModule,
    PhxTooltipModule,
    PhxTranslationsRootModule,
  ],
  declarations: [
    PhxDraggableListComponent,
  ],
  exports: [
    PhxDraggableListComponent,
  ],
})
export class PhxDraggableListModule { }
